//main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { createPinia } from 'pinia'
// import { useHomeStore } from '@/store/homeStore'
// import { useProductsStore } from '@/store/productsStore'
import 'sweetalert2/dist/sweetalert2.min.css'; // 引入樣式
import VueLazyload from 'vue-lazyload'
// element-plus 已移除：全站沒有任何元件用到它（只有 main.js 註冊 + Profile 的死碼 locale），移除後大幅減少 JS/CSS
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//版本
import { useVersionStore } from '@/store/versionStore'
import { loadGifts, loadCoupons } from '@/utils/promoData'
// 匯入 Bootstrap 的 CSS
import { createHead } from '@vueuse/head'

// 2) 引入你需要使用的 icon
import {
    faAngleUp,
    faAngleDown,
    faTrash,
    faUser,
    faShoppingCart,
    faUsers,
    faBoxes,
    faBell,
    faFileCode,
    faImages,
    faBook,
    faCogs,
    faCreditCard,
    faStore,
    faCalendarCheck,
    faScissors,
    faTag,
    faBullhorn,
    faGauge,
    faHandshake,
    faMoneyBillWave,
    faChartLine,
    faFileInvoiceDollar
} from '@fortawesome/free-solid-svg-icons';

import { faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons'


async function bootstrap() {


    library.add(
        faAngleUp,
        faAngleDown,
        faTrash,
        faUser,
        faShoppingCart,
        faUsers,
        faBoxes,
        faBell,
        faFileCode,
        faImages,
        faBook,
        faCogs,
        faCreditCard,
        faStore,
        faCalendarCheck,
        faScissors,
        faTag,
        faBullhorn,
        faGauge,
        faHandshake,
        faMoneyBillWave,
        faFileInvoiceDollar,
        faChartLine,
        faCcMastercard,
        faCcVisa
    );

    const app = createApp(App);


    const head = createHead()
    app.use(head)

    const pinia = createPinia()
    app.use(pinia)


    // 滿額贈 / 折扣券：網站一打開就開始抓，與版本檢查同時進行（各頁面共用同一份，不必排在版本檢查後面）
    loadGifts()
    loadCoupons()

    // 3. 現在才能透過 `useVersionStore()` 拿到「真正的 store 實例」
    const versionStore = useVersionStore()
    // 4. 版本檢查：回訪客人（瀏覽器已有設定快取）先用快取立刻顯示網站，檢查改在背景跑；
    //    第一次來（沒有快取）才需要等它跑完，才拿得到公司名稱等設定
    const hasCachedSettings = !!localStorage.getItem('settings')
    const versionCheck = versionStore.checkServerVersion()
    if (!hasCachedSettings) await versionCheck
    // 2. 呼叫 versionStore.getSettings() 拿到設定（可能是物件或字串）
    const settings = await versionStore.getSettings()
    const posterTitles = await versionStore.getPosterTitles();
    if (hasCachedSettings) {
        // 背景檢查完成後，把最新設定/文章標題更新進同一個物件（其他地方拿到的參考會一起更新）
        versionCheck.then(async () => {
            const fresh = await versionStore.getSettings()
            if (fresh && settings && typeof settings === 'object') Object.assign(settings, fresh)
            const freshTitles = await versionStore.getPosterTitles()
            if (Array.isArray(freshTitles) && Array.isArray(posterTitles)) posterTitles.splice(0, posterTitles.length, ...freshTitles)
        }).catch(() => { /* 背景檢查失敗不影響網站 */ })
    }

    // 5. 取得 settings
    app.config.globalProperties.$Settings = settings

    app.config.globalProperties.$PosterTitles = posterTitles

    app.config.globalProperties.$COMPANY_NAME = settings.COMPANY_NAME;
    app.config.globalProperties.$COMPANY_NAMEn = settings.COMPANY_NAMEN;
    app.config.globalProperties.$COMPANY_TAXID = settings.COMPANY_TAXID;
    

    console.log(settings)

    // 可在這裡傳入一些全域設定，例如 loading/error 圖
    app.use(VueLazyload, {
        observerOptions: {
            rootMargin: '0px',
            threshold: 0.1
        }
    })

    router.beforeEach((to, from, next) => {
       // document.title = to.meta.title || settings.COMPANY_NAMEN + ' | 自然與科技結合的極致護膚';
       // const defaultTitle = settings.COMPANY_NAMEN + ' | ' + "自然與科技結合的極致護膚";
        if (to.meta?.serverTitle && from.matched.length === 0) {
            // 首次進站：沿用伺服器注入的商品/文章標題（避免搜尋引擎在載入中拍到「JiLi | 產品」）
        } else if (to.meta?.title) {
            // 你自己看是要把「|」寫在 meta 內，還是這裡寫
            document.title = to.meta.title;
        } else {
            document.title = settings.COMPANY_NAME;
        }
        next();
    });

    app.directive('intersect', {
        mounted(el, binding) {
            const options = {
                threshold: 0.1 // 触发回调的阈值
            };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        binding.value(entry); // 调用绑定的方法
                    }
                });
            }, options);
            observer.observe(el);
        }
    });

    /* 讓 <font-awesome-icon icon="trash" /> 生效 */
    app.component('font-awesome-icon', FontAwesomeIcon)
    app.use(router);
    app.use(store);
    app.mount('#app');

}

// 執行 bootstrap
bootstrap()
